import { useSelector } from 'react-redux'

import { currentStepSelector, redeemErrorSelector } from 'features'

import { LinearProgress } from '@mui/material'
import { REDEEM_PROGRESS_STEPS } from '../redeem-progress-modal.config'

import { useStyles } from '../redeem-progress-modal.styles'
import { RedeemStepsE } from 'types'

const ProgressBar = (): JSX.Element | null => {
  const { classes } = useStyles()

  const currentStep = useSelector(currentStepSelector)
  const redeemError = useSelector(redeemErrorSelector)

  if (currentStep === RedeemStepsE.NFT_BURNED || redeemError) {
    return null
  }

  return (
    <div style={{ width: 200, paddingBottom: '32px', margin: '0 auto' }}>
      <LinearProgress
        variant="determinate"
        value={REDEEM_PROGRESS_STEPS[currentStep].progress}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    </div>
  )
}

export { ProgressBar }
